import { addDays, differenceInMonths, isBefore, isEqual, isLeapYear } from 'date-fns';
import * as Yup from 'yup';

export function reportingSchema() {
  return Yup.object().shape({
    name: Yup.string().required('Required Field'),
    date: Yup.array()
      .test('require date', 'Required Field', (value) => {
        if (value) {
          return value[0] && value[1];
        }

        return false;
      })
      .test('invalid-date', 'end date cannot be before start date', (value) => {
        if (value) {
          const startDate = new Date(value[0]);
          const endDate = new Date(value[1]);

          return isEqual(startDate, endDate) || isBefore(startDate, endDate);
        }

        return false;
      })
      .test('this-year', 'Maximum date range is 12 months', (value) => {
        if (value) {
          const start = new Date(value[0]);
          const end = new Date(value[1]);

          const startDate = isLeapYear(start) ? addDays(start, 1) : start;
          const endDate = isLeapYear(end) ? addDays(end, 1) : end;

          return differenceInMonths(endDate, startDate) <= 11;
        }

        return false;
      })
      .of(Yup.string().nullable()),
    statuses: Yup.array().of(Yup.string()).min(1, 'At least one status must be selected'),
    riders: Yup.array().of(Yup.object()).min(1, 'At least one rider must be selected'),
    categories: Yup.array().of(Yup.object()).min(1, 'At least one category must be selected'),
  });
}
